import { parsePaise } from '../payments/allocation';
const small = [
  'Zero',
  'One',
  'Two',
  'Three',
  'Four',
  'Five',
  'Six',
  'Seven',
  'Eight',
  'Nine',
  'Ten',
  'Eleven',
  'Twelve',
  'Thirteen',
  'Fourteen',
  'Fifteen',
  'Sixteen',
  'Seventeen',
  'Eighteen',
  'Nineteen',
];
const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
function words(n: bigint): string {
  if (n < 20n) return small[Number(n)];
  if (n < 100n) return tens[Number(n / 10n)] + (n % 10n ? '-' + words(n % 10n) : '');
  for (const [size, label] of [
    [10000000n, 'Crore'],
    [100000n, 'Lakh'],
    [1000n, 'Thousand'],
    [100n, 'Hundred'],
  ] as const) {
    if (n >= size) return words(n / size) + ' ' + label + (n % size ? ' ' + words(n % size) : '');
  }
  throw new Error('Invalid amount');
}
export function amountInWords(value: string): string {
  const paise = parsePaise(value);
  return (
    'Rupees ' +
    words(paise / 100n) +
    (paise % 100n ? ' and ' + words(paise % 100n) + ' Paise' : '') +
    ' Only'
  );
}
